// Builders
import buildCartTrackingData from "./builders/buildCartTrackingData"

// Classes
import { CartTrackingData } from "./classes/CartTrackingData"

function trackReservationClick(
	eventName: string,
	quantity: number,
	prestIds: string[],
	prestNames: string[],
	itemPriceAti: number,
	beginDate: string,
	endDate: string,
	duration: number,
	liheId: string,
	liheName: string,
	region: string,
	station: string
): void {
	const cartTrackingData: CartTrackingData = buildCartTrackingData(
		quantity,
		prestIds,
		prestNames,
		itemPriceAti,
		beginDate,
		endDate,
		duration,
		liheId,
		liheName,
		region,
		station
	)

	window.dataLayer.push(cartTrackingData)
	window.dataLayer.push({ event: eventName })
}

export default trackReservationClick
